import { render, staticRenderFns } from "./paymentDetail.vue?vue&type=template&id=4f65387e"
import script from "./paymentDetail.vue?vue&type=script&lang=js"
export * from "./paymentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports